import React from 'react'

import { WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import i18n from 'modules/core/lib/i18n'

import { BankAccountMembershipSelector } from 'modules/banking/components/BankAccountMembershipSelector'
import { WizardData } from 'modules/banking/components/FinishSetupAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/FinishSetupAccountModal/wizardSteps/WizardStepLayout'

export const FinishSetupMembershipsWizardStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<WizardData>) => {
  const [selectedEmployees, setSelectedEmployees] =
    React.useState<EmployeeForSelectFragmentNoAccess[]>()
  const handleSelectEmployees = (newEmployees: EmployeeForSelectFragmentNoAccess[]) => {
    setSelectedEmployees(newEmployees)
    onDataChanged({ ...data, membershipsEmployeeIds: newEmployees.map((employee) => employee.id) })
  }

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.finish_wizard.step_3.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_3.subtitle')}
    >
      <BankAccountMembershipSelector
        selectedEmployees={selectedEmployees}
        handleSelectEmployees={handleSelectEmployees}
      />
    </WizardStepLayout>
  )
}
